class RetryWorker {
    constructor(attemptLimit, intervalBetweenAttempts, attemptRoutine, successRoutine, failureRoutine) {
        this.attemptLimit = attemptLimit;
        this.intervalBetweenAttempts = intervalBetweenAttempts;
        this.attemptRoutine = attemptRoutine;
        this.successRoutine = successRoutine;
        this.failureRoutine = failureRoutine;
    }

    doWork(self, loopCount = 1) {
        if(!self){
            self = this;
        }
        if(loopCount >= self.attemptLimit){
            if(self.failureRoutine) self.failureRoutine();
            return false;
        }
        else{
            return self.attemptRoutine()
                .then(isSuccess =>{
                    if(isSuccess){
                        if(self.successRoutine) self.successRoutine(isSuccess);
                        return true;
                    }
                    else{
                        throw new Error("result null");
                    }
                })
                .catch(err => {
                    setTimeout(()=>{
                        return self.doWork(self, ++loopCount);
                    }, self.intervalBetweenAttempts)
                })
        }
    }
}

module.exports = RetryWorker;